<!-- Кнопка сворачивания фильтров (только на мобильных) -->
<button
  type="button"
  class="find-tracks-toggle"
  [class.find-tracks-toggle--open]="filtersOpen"
  [attr.aria-expanded]="filtersOpen"
  (click)="toggleFilters()"
>
  <span class="find-tracks-toggle__icon" aria-hidden="true">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 3.5h13M4 8h8M6.5 12.5h3"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </span>
  <span class="find-tracks-toggle__label">{{ lg.sortTrackBy.mobileFilters.toggle }}</span>
  @if (activeFilterCount) {
    <span class="find-tracks-toggle__badge">{{ activeFilterCount }}</span>
  }
  <span class="find-tracks-toggle__chevron" aria-hidden="true">
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 4.5 6 7.5l3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </span>
</button>

<div class="find-tracks" [class.find-tracks--open]="filtersOpen">
  <!-- Sort tracks: top / newest -->
  <bmcore-sort-tracks-select
    [isBeatmakerPage]="isBeatmakerPage"
    [isFreeBeatsPage]="isFreeBeatsPage"
    [currentSortById]="currentSortById"
    (filterTracksEvent)="filterTracksEvent.emit($event)"
  >
  </bmcore-sort-tracks-select>

  <!-- Styles select -->
  <bmcore-style-select [styleId]="styleId" (filterTracksEvent)="filterTracksEvent.emit($event)"> </bmcore-style-select>

  <!-- Mood select -->
  <bmcore-mood-select [moodId]="moodId" (filterTracksEvent)="filterTracksEvent.emit($event)"> </bmcore-mood-select>

  @if (showSearchFields) {
    <!-- Search by tag -->
    <bmcore-search-tag-input
      [searchTagTitle]="searchTagTitle"
      [isTagDropdown]="isTagDropdown"
      [tags]="searchResponse"
      (changeTagsValueEvent)="searchValueChangeHandler($event)"
      (findTagsEvent)="findTracksByTag($event)"
      (showBeatmakerDropdownEvent)="showBeatmakerDropdown($event)"
      (showTagDropdownEvent)="showTagDropdown($event)"
      (clearSearchTagTileEvent)="clearSearchTagTitle()"
    >
    </bmcore-search-tag-input>
    <!-- Search by beat -->
    <bmcore-search-beat-input [searchTrack]="searchTrack" (changeBeatValueEvent)="searchValueChangeHandler($event)">
    </bmcore-search-beat-input>
    <!-- Search by beatmaker name -->
    @if (!isBeatmakerPage) {
      <bmcore-search-beatmaker-input
        [beatmakers]="searchResponse"
        [isBeatmakerDropdown]="isBeatmakerDropdown"
        [searchBeatmakerTitle]="searchBeatmakerTitle"
        (showTagDropdownEvent)="showTagDropdown($event)"
        (findTracksByBeatmakerNameEvent)="findTracksByBeatmakerName($event)"
        (changeBeatmakerValueEvent)="searchValueChangeHandler($event)"
        (showBeatmakerDropdownEvent)="showBeatmakerDropdown($event)"
        (clearSearchBeatmakerTitleEvent)="clearSearchBeatmakerTitle()"
      >
      </bmcore-search-beatmaker-input>
    }
  }

  @if (showCatalogFilters) {
    <!-- Track type -->
    <bmcore-dictionary-select
      [label]="lg.sortTrackBy.trackType.label"
      [allOptionLabel]="lg.sortTrackBy.trackType.allOption"
      [items]="trackTypes"
      [value]="trackTypeId"
      [filterTitle]="'track-type'"
      (filterTracksEvent)="filterTracksEvent.emit($event)"
    >
    </bmcore-dictionary-select>

    <!-- Key -->
    <bmcore-dictionary-select
      [label]="lg.sortTrackBy.key.label"
      [allOptionLabel]="lg.sortTrackBy.key.allOption"
      [items]="keys"
      [value]="keyId"
      [filterTitle]="'key'"
      (filterTracksEvent)="filterTracksEvent.emit($event)"
    >
    </bmcore-dictionary-select>

    <!-- Instruments -->
    <bmcore-dictionary-select
      [label]="lg.sortTrackBy.instruments.label"
      [items]="instruments"
      [selectedIds]="instrumentIds"
      [multiple]="true"
      [showModeToggle]="true"
      [mode]="instrumentsMode"
      [andLabel]="lg.sortTrackBy.multiSelectMode.and"
      [orLabel]="lg.sortTrackBy.multiSelectMode.or"
      [filterTitle]="'instruments'"
      (filterTracksEvent)="filterTracksEvent.emit($event)"
    >
    </bmcore-dictionary-select>

    <!-- BPM range -->
    <bmcore-range-filter
      [label]="lg.sortTrackBy.bpm.label"
      [fromLabel]="lg.sortTrackBy.range.from"
      [toLabel]="lg.sortTrackBy.range.to"
      [filterTitle]="'bpm'"
      [from]="bpmFrom"
      [to]="bpmTo"
      [min]="0"
      (filterTracksEvent)="filterTracksEvent.emit($event)"
    >
    </bmcore-range-filter>

    <!-- Price range -->
    <bmcore-range-filter
      [label]="lg.sortTrackBy.price.label"
      [fromLabel]="lg.sortTrackBy.range.from"
      [toLabel]="lg.sortTrackBy.range.to"
      [filterTitle]="'price'"
      [from]="priceFrom"
      [to]="priceTo"
      [min]="0"
      (filterTracksEvent)="filterTracksEvent.emit($event)"
    >
    </bmcore-range-filter>
  }
</div>

@if (showCatalogFilters) {
  <div class="find-tracks__selected">
    <bmcore-selected-tags
      [tags]="selectedTags"
      [mode]="tagsMode"
      [andLabel]="lg.sortTrackBy.multiSelectMode.and"
      [orLabel]="lg.sortTrackBy.multiSelectMode.or"
      [removeLabel]="lg.sortTrackBy.tags.remove"
      (removeTagEvent)="removeTag($event)"
      (changeModeEvent)="changeTagsMode($event)"
    >
    </bmcore-selected-tags>

    @if (hasActiveFilters) {
      <button type="button" class="find-tracks__clear" (click)="clearFilters()">
        {{ lg.sortTrackBy.clearFilter }}
      </button>
    }
  </div>
}
